import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';
import ProductItem from '../products/item.js';
import searchProducts from '../../lib/search-products.js';
import './equipment-product-list.css';

export class EquipmentVendorProducts extends React.PureComponent {
  state = {
    products: [],
    loading: false,
    loaded: false,
  };

  componentDidMount() {
    this.fetchProducts();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.vendorId !== this.props.vendorId ||
      prevProps.locationId !== this.props.locationId
    ) {
      this.fetchProducts();
    }
  }

  fetchProducts() {
    const { vendorId, locationId } = this.props;
    if (!locationId) return;

    const filters = vendorId
      ? `active:true AND _tags:vendor_${vendorId}`
      : 'active:true';

    this.setState({ loading: true });
    searchProducts(locationId, {
      query: '',
      hitsPerPage: 12,
      filters,
    })
      .then((resp) => {
        this.setState({
          products: resp.hits || [],
          loading: false,
          loaded: true,
        });
      })
      .catch(() => {
        this.setState({ products: [], loading: false, loaded: true });
      });
  }

  render() {
    const { products, loading, loaded } = this.state;

    if (loading) {
      return (
        <div className="equipment-product-list loading">
          <Loader active inline="centered" size="small" />
        </div>
      );
    }

    if (loaded && !products.length) return null;
    if (!loaded) return null;

    return (
      <div className="equipment-product-list">
        <h4 className="product-list-name">
          {this.props.vendorName
            ? `More Products from ${this.props.vendorName}`
            : 'More Products'}
        </h4>
        <div className="equipment-products-grid">
          {products.map((product) => (
            <ProductItem key={product.objectID} item={product} canFavorite={false} />
          ))}
        </div>
        <div className="equipment-view-more">
          <Link
            to={this.props.vendorId
              ? `/supplies/catalog-search?cart_minimum=${this.props.vendorId}`
              : '/supplies/catalog-search'}
            className="equipment-view-more-btn"
          >
            View More Products
          </Link>
        </div>
      </div>
    );
  }
}

EquipmentVendorProducts.propTypes = {
  vendorId: PropTypes.number,
  vendorName: PropTypes.string,
  locationId: PropTypes.number,
};

function mapStateToProps(state) {
  const ms = state.equipment.minimumSpend;
  const vendors = state.locations.open.vendors || [];
  const vendor = vendors.find((v) => v.id === ms.vendor_id);
  return {
    vendorId: ms.vendor_id,
    vendorName: vendor ? vendor.name : null,
    locationId: state.locations.open.id,
  };
}

export default connect(mapStateToProps)(EquipmentVendorProducts);
